module.exports = __webpack_public_path__ + "img/tombstone.2d736b12.svg";